export enum permissions {
  PUBLIC = 'public',
  PIN = 'pin',
  GROUP = 'group'
}
